import {
  GAME_ID_FROM_URL,
  ONE_DAY_TEEN_PATTI_BACK_AND_LAY_ID,
} from '@ezugi/constants';

export const isBackAndLayOnURL = GAME_ID_FROM_URL === ONE_DAY_TEEN_PATTI_BACK_AND_LAY_ID;

export const notNil = (x) => x != null;
